// Librairies
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

// Interfaces
// The title settings of a widget, in widget.design.title.
export interface WidgetTitleDesign {
  display?: boolean;
  fontSize?: number;
  align?: 'start' | 'center' | 'end';
  position?: 'top' | 'bottom';
  icon?: string | null;
  description?: string | null;
}

// Classes
// With an icon or a description: the rich header; otherwise each widget keeps its own title.
export function hasRichTitle(design?: WidgetTitleDesign | null): boolean {
  return !!(design?.icon || design?.description?.trim());
}

// Widget header like the mock-ups: icon, title, description in grey; the projected content (a badge) on the right.
@Component({
  selector: 'app-widget-title',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './widget-title.component.html',
  styleUrl: './widget-title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class WidgetTitleComponent {
  // Variables
  @Input() title: string = '';
  @Input() design?: WidgetTitleDesign | null;
}
